import React from "react";
import { DownloadOutlined } from "@ant-design/icons";
import GlobalButton from "../../../../shared/globalStyling/Button";
import { Row, Space } from "antd";
import { isEmpty } from "lodash";
import { CSVLink } from "react-csv";
import moment from "moment";

//Export Buttons on the top right of the page
const ExportButtons = ({
  exportData = false,
  reportData,
  currentTab = "summary",
  name = "",
}) => {
  if (exportData) {
    const filename = `${
      currentTab ? currentTab.replace(/[\W_]/g, "_") : "summary"
    }_${name}_${moment.utc().format("MMMM DD YYYY")}`;
    return (
      <React.Fragment>
        <Row>
          <Space className="ant-space-xs-vertical ant-space-md-horizontal ant-space-xs-gap-small ant-space-md-gap-middle">
            <GlobalButton disabled={isEmpty(reportData)} type="primary">
              <CSVLink filename={`${filename}.csv`} data={reportData}>
                <Space size="small" direction="horizontal">
                  <DownloadOutlined />
                  Export CSV
                </Space>
              </CSVLink>
            </GlobalButton>
            <GlobalButton disabled={isEmpty(reportData)} type="primary">
              <CSVLink filename={`${filename}.xlsx`} data={reportData}>
                <Space size="small" direction="horizontal">
                  <DownloadOutlined />
                  Export Excel
                </Space>
              </CSVLink>
            </GlobalButton>
          </Space>
        </Row>
      </React.Fragment>
    );
  }
  //Don't show anything if exportData is false
  return <></>;
};

export default ExportButtons;
